module.exports = __webpack_public_path__ + "img/Virtual_Art.54ea5514.png";